<div class="ui-g" >
  <div class="ui-g-12 ui-md-12 ui-lg-12 background">
    <div class="ui-g-12 p-text-left">
      <h2 class="title">Configuraciones</h2>
    </div>
  </div>
    <div class="ui-g-8 ui-md-8 ui-sm-12" style="margin: 0 auto;">
      <div class="ui-g-12 ui-fluid">
        <p-selectButton [options]="types" (onOptionClick)="test($event)" [(ngModel)]="selectedType" style="width: 100%;"></p-selectButton >
        <div *ngIf="selectedType == 0; then session else update"></div>
      </div>
      <div class="ui-g-12">
        <ng-template #update>
          <div class="cardGray ui-g-12 ui-md-12 ui-lg-12">
            <div class="ui-g-12">
              <h2 class="subTitle">Actualizar información</h2>
            </div>
            <div class="ui-g-12">
              <div class="ui-g-12 form-group">
                <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
                  <div class="ui-g-12">
                    <h4 class="subTitle2">Correo electrónico</h4>
                    <input formControlName="email" id="float-input-email" type="email" size="40"  pInputText >
                    <p-message severity="error" text="correo electrónico es requerido" *ngIf="!userform.controls['email'].valid&&userform.controls['email'].dirty"></p-message>
                  </div>
                  <div class="ui-g-12">
                    <div class="ui-g-12">
                      <h4 class="subTitle2">Número de teléfono</h4>
                    </div>
                    <div class="ui-g-6 ui-md-6 ui-sm-12">
                        <p-dropdown [options]="items"  formControlName="country"  placeholder="{{countryTitle}}" optionLabel="idCode" [showClear]="true" [virtualScroll]="false" [itemSize]="33" [filter]="false"></p-dropdown>
                        <p-message severity="error" text="seleccione país" *ngIf="!userform.controls['country'].valid&&userform.controls['country'].dirty"></p-message>
                    </div>
                    <div class="ui-g-6 ui-md-6 ui-sm-12">
                        <input id="float-input" type="text" (keypress)='validate($event)' size="8"  pInputText formControlName="phoneNumber" >
                        <p-message severity="error" text="número de teléfono es requerido" *ngIf="!userform.controls['phoneNumber'].valid&&userform.controls['phoneNumber'].dirty"></p-message>
                    </div>
                  
                   
                  </div>
                  <div class="ui-g-12">
                    <h4 class="subTitle2">Documento de identificación</h4>
                    <input id="float-input-dpi" type="text" (keypress)='validate($event)' size="30"  pInputText formControlName="dpi" >
                    <p-message severity="error" text="dpi es requerido" *ngIf="!userform.controls['dpi'].valid&&userform.controls['dpi'].dirty"></p-message>
                  </div>
                  <div class="ui-g-12">
                    <button class="ui-button ui-fluid btn" pButton type="submit" label="{{loginBtnTitle}}" [disabled]="!userform.valid" ></button>
                  </div>
                </form>
                <p-messages></p-messages>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template #session> 
          <div class=" cardGray ui-g-12">
            <div class="ui-g-12">
              <h2 class="subTitle">Dispositivos que tienen acceso a la cuenta</h2>
            </div>
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <p-dataView #dv [value]="sessionResponse" [paginator]="false" [rows]="10" paginatorPosition="bottom"
                           layout="list" >
               <!-- <p-header>
                  <div style="position: relative">
                    <input type="search" pInputText placeholder="Búsqueda por dispositivo" (input)="dv.filter($event.target.value, 'contains')">
                    <i style="float: left" class="pi pi-search search-icon" ></i>
                  </div>
                </p-header>-->
                <ng-template let-product pTemplate="listItem">
                  <div class="ui-g-12" >
                    <div class="car-details ui-g-12">
                      <div>
                        <div class="ui-fluid">
                          <div class="ui-g-4"> <b>{{product.description}}</b></div>
                          <div class="ui-g-4"> <b *ngIf="product.logs.length > 0">{{product.logs[0].state}}</b></div>
                          <!--<div class="ui-g-4"> <b *ngIf="product.logs.length > 0">{{product.logs[0].date}}</b></div>-->
                          <div class="ui-g-4"> <b *ngIf="product.logs.length > 0">{{product.logs[0].date | date : 'dd/MM/yyyy hh:mm' : 'UTC'}}</b></div>
                          <!--<div class="ui-g-2">
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteProduct(product)"></button>
                          </div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template pTemplate="summary">
                  <div class="p-d-flex p-ai-center p-jc-between">
                    In total there are {{product ? sessionResponse.length : 0 }} products.
                  </div>
                </ng-template>
              </p-dataView>
              <!--<p-table #dt [value]="sessionResponse" [rows]="10" [paginator]="true" [globalFilterFields]="['name','description']"
                       [(selection)]="selectedProducts" [rowHover]="true" dataKey="id"
                       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                  <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">Manage Products</h5>
                    <span class="p-input-icon-left">
                              <i class="pi pi-search"></i>
                              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                          </span>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 3rem">
                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                    </th>
                    <th pSortableColumn="name">Descripción <p-sortIcon field="name"></p-sortIcon></th>
                    <th>Image</th>
                    &lt;!&ndash;<th pSortableColumn="price">Estatus <p-sortIcon field="price"></p-sortIcon></th>
                    <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th>
                    <th pSortableColumn="rating">Reviews <p-sortIcon field="rating"></p-sortIcon></th>
                    <th pSortableColumn="inventoryStatus">Status <p-sortIcon field="inventoryStatus"></p-sortIcon></th>&ndash;&gt;
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                  <tr>
                    <td>
                      <p-tableCheckbox [value]="product"></p-tableCheckbox>
                    </td>
                    <td>{{product.description}}</td>
                    &lt;!&ndash; <td><img [src]="'assets/showcase/images/demo/product/' + product.image" [alt]="product.name" width="100" class="p-shadow-4" /></td>
                     <td>{{product.price | currency:'USD'}}</td>
                     <td>{{product.category}}</td>
                     <td><p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating></td>
                     <td><span [class]="'product-badge status-' + (product.inventoryStatus ? product.inventoryStatus.toLowerCase() : '')">{{product.inventoryStatus}}</span></td>&ndash;&gt;
                    <td>
                      &lt;!&ndash;<button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editProduct(product)"></button>&ndash;&gt;
                      <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteProduct(product)"></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>-->
            </div>
          </div>
        
        </ng-template>
      </div>
     
    
    </div>
</div>

